import { render, staticRenderFns } from "./appraiseTaskTemplate.vue?vue&type=template&id=18bed300&scoped=true&"
import script from "./appraiseTaskTemplate.vue?vue&type=script&lang=js&"
export * from "./appraiseTaskTemplate.vue?vue&type=script&lang=js&"
import style0 from "./appraiseTaskTemplate.vue?vue&type=style&index=0&id=18bed300&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bed300",
  null
  
)

export default component.exports